import { useGroupIcon } from 'hooks'
import { Group } from 'lib/_types'
import { PLACEHOLDER_USER_COVER_IMAGE } from 'lib/image'

import ImageLoader from 'components/ImageLoader'

const GroupImage = ({
  className,
  placeholderImageTrans,
  group,
  fallbackToGroupCover,
}: {
  className?: string
  placeholderImageTrans?: boolean
  group: Group
  fallbackToGroupCover?: boolean
}) => {
  const { getGroupIcon } = useGroupIcon({ fallbackToGroupCover })

  const groupIcon = getGroupIcon({ group })

  return (
    <ImageLoader
      className={className}
      url={groupIcon?.icon}
      placeholderImage={groupIcon?.placeholder ?? PLACEHOLDER_USER_COVER_IMAGE}
      placeholderImageTrans={placeholderImageTrans}
      alt={`${group?.topic}のカバー写真`}
    />
  )
}

export default GroupImage
